import Vue from "vue";
import Vuex from "vuex";
import ElementUI from "element-ui";
import { MessageBox } from "element-ui";
import echarts from "echarts";
import "echarts-liquidfill";
import VueAwesomeSwiper from "vue-awesome-swiper";
import App from "./App";
import router from "./router";
import "default-passive-events";
import store from "./store";
import VideoPlayer from "vue-video-player";
import * as custom from "@/utils/time";
import Permission from "./directive/permission";
import VueCropper from "vue-cropper";
import {
  getToken,
  getUuid,
  setToken,
  setUuid,
  getroleId,
  setuserPhone,
  setroleId,
  setuserName,
  setheadPath,
  setschoolId,
  setschoolCode,
  setareaId,
  setrank,
  setIsAdmin,
  setorganFlag
} from "@/utils/auth";
import lottie from "vue-lottie"; //动画
import UUID from "vue-uuid";
import JSEncrypt from "jsencrypt";
import {
  pcToken,
  webToken,
  getAccount,
  judgeCubeIsBind,
  getBoundLoginInfo
} from "@/api/login";
import { info } from "@/api/usermenu";
import { menuButtonByToken } from "@/api/power";
import { buryingPoint } from "@/api/cockpit.js"; //数据驾驶舱埋点
import { loadinguploadtitle } from "./assets/js/wx-upload"; // 上传应用时遮罩层
import elTableInfiniteScroll from "el-table-infinite-scroll";
import { borderBox12 } from "@jiaminghi/data-view";
import htmlToPdf from "@/utils/htmlToPdf.js";
import documentPdf from "@/utils/documentPdf.js";
import { importDateError } from "@/utils/functionAll";

import Chart from "chart.js";
import VueChartkick from "vue-chartkick";

import quillEditor from "vue-quill-editor"; // 富文本编辑
import "quill/dist/quill.core.css"; // 富文本编辑 css
import "quill/dist/quill.snow.css"; // 富文本编辑css
import "quill/dist/quill.bubble.css"; // 富文本编辑 css
import * as Quill from "quill";
// 拖拽上传
import { ImageDrop } from "quill-image-drop-module";
// 调整上传图片大小
import ImageResize from "quill-image-resize-module";
// 粘贴图片上传
import { ImageExtend } from "quill-image-paste-module";
// 注册事件~~~~
Quill.register("modules/imageDrop", ImageDrop);
Quill.register("modules/imageResize", ImageResize);
Quill.register("modules/ImageExtend", ImageExtend);

// import '@/styles/iconfont.css'
// import "@/assets/font/iconfont";
import "default-passive-events";
import "element-ui/lib/theme-chalk/index.css";
// import 'swiper/dist/css/swiper.css'
import "swiper/swiper-bundle.css";
import "babel-polyfill";
import "@/styles/common.css";
import "@/styles/common.styl";
import "@/styles/whole.css";
import "@/styles/ThesUnifiedStyle.styl";
import "videojs-flash";
import "./assets/js/parseInt";
import "./iconfont_svn/iconfont";
import "./iconfont_svn/iconfont.css";
import 'animate.css';
import "video.js/dist/video-js.css"; // video.js
const Base64 = require("js-base64").Base64;
import { Loading } from "element-ui";
import platformCode from "./utils/global-variable";

// import './mock/mock-server'
Vue.component("lottie", lottie);

Vue.prototype.$imerr = importDateError;
Vue.prototype.$platformCode = platformCode;

require("video.js/dist/video-js.css");
require("vue-video-player/src/custom-theme.css");
const hls = require("videojs-contrib-hls");
Object.keys(custom).forEach(key => {
  Vue.filter(key, custom[key]);
});
Vue.config.productionTip = false;
Vue.prototype.$echarts = echarts;
Vue.prototype.SHADE = loadinguploadtitle;
Vue.use(VueCropper);
Vue.use(UUID);
Vue.use(hls);
Vue.use(VideoPlayer);
Vue.use(Permission); //权限按钮
Vue.use(Vuex);
Vue.use(ElementUI);
Vue.use(VueAwesomeSwiper);
Vue.use(elTableInfiniteScroll);
Vue.use(borderBox12);
Vue.use(quillEditor); // 富文本编辑

Vue.use(htmlToPdf); // html转pdf
Vue.use(documentPdf); //公文管理导出PDF

Vue.use(VueChartkick, {
  adapter: Chart
});

//rsa 解密全局方法
Vue.prototype.$sendEncryCode = function(params) {
  let jse = new JSEncrypt();
  let privKey = `-----BEGIN PRIVATE KEY-----
    MIICdQIBADANBgkqhkiG9w0BAQEFAASCAl8wggJbAgEAAoGBAKYGNM2g1siOtlWg
    S3k4E0zrNn/INnvCC/ncDp6RO4Cyp8neNeYsLs+qqsnGCqoN/aXvYKdELxnEgCSJ
    QGYgr8UgOuWoIE+XWHRibyo8uZS6/mXfGaGVvr5r+/bbjjg9b9TpSvSXUG9sKiuu
    xZXeV4UV8tnmhPiar2NfORAu/wXrAgMBAAECf0qUfyPgHJv7f+z3FPBfQExNXS4J
    wm/Vu4uCTw7sLs6hcr48E/pR3rVq9U2uqRu7LTZdUg3Rk1b/7pB7F3LJPCuX5n/t
    nqcEWfWoyAc6wnVLffxkvx7toD7nMl7+2/LsUgSiY/QFdG43dKs+5rXuEOOwcZV/
    tLdivN9SEN44mEECQQDXls/rpMPYnd0IHHqh6YZEA3dH1CZAWeW/4XF/BINW/02m
    jtoNr+sTcZN9ekaLFTQnF/jJRi35dNwGhroG+k/hAkEAxST9oYDugGPTbu81JU1p
    nO8tLQPHvpVu3lGQEFahWZi6j70FlhNEhX74lDLrhvTOI4ohzHX28pU5TbQkiyl/
    SwJBALxQseHmFGR80HurVLtlnrB+TozhlWAUpolLRbZrnMY7T/qzQWk/Rxm+1dR/
    IGuQ4/NaDyjRMot6Nk9FE+3QbEECQQCXib+MDVdHSXSUqTro2YB9KTxIhcdcL/Fw
    4rEiXfTYshV1t447tcPN+bOJ9zokGrj5iIxCZcrU3O+XUwlkDxnRAkArwYiJZFlS
    Lu9zj+e03+kGWu6c/x8RRoLqfZcWFffBZlkxOHa06aN6jYCdJtRON43JUbynMvDY
    l5glkcwnZlbi
    -----END PRIVATE KEY-----`;

  jse.setPrivateKey(privKey);
  let data = jse.decrypt(params); //解密

  return data;
};

//rsa 加密全局方法
Vue.prototype.$getRsaCode = function(str) {
  // 注册方法

  let pubKey = `-----BEGIN PUBLIC KEY-----
    MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCmBjTNoNbIjrZVoEt5OBNM6zZ/
    yDZ7wgv53A6ekTuAsqfJ3jXmLC7PqqrJxgqqDf2l72CnRC8ZxIAkiUBmIK/FIDrl
    qCBPl1h0Ym8qPLmUuv5l3xmhlb6+a/v22444PW/U6Ur0l1BvbCorrsWV3leFFfLZ
    5oT4mq9jXzkQLv8F6wIDAQAB
    -----END PUBLIC KEY-----`; // ES6 模板字符串 引用 rsa 公钥
  let encryptStr = new JSEncrypt();
  encryptStr.setPublicKey(pubKey); // 设置 加密公钥
  let data = encryptStr.encrypt(str.toString()); // 进行加密

  return data;
};

Vue.prototype.openLoading = function(data) {
  const loading = this.$loading({
    // 声明一个loading对象
    lock: true, // 是否锁屏
    text: "上传中，请稍等！", // 加载动画的文字
    spinner: "el-icon-loading", // 引入的loading图标
    background: "rgba(0, 0, 0, 0.8)", // 背景颜色
    target: ".el-table, .table-flex, .region", // **需要遮罩的区域，这里写要添加loading的选择器**
    fullscreen: false,
    customClass: "loadingclass" // **遮罩层新增类名，如果需要修改loading的样式**
  });
  return loading;
};

// 全局按钮节流
import { preventReClick } from "@/utils/preventReClick";

Vue.prototype.$preventReClick = preventReClick; // 节流函数

function delCookie() {
  var keys = document.cookie.match(/[^ =;]+(?==)/g);
  if (keys) {
    for (var i = keys.length; i--; ) {
      document.cookie =
        keys[i] + "=0;path=/;expires=" + new Date(0).toUTCString();
    }
  }
}
//
Vue.prototype.resetSetItem = function(key, newVal) {
  if (key === "oaState") {
    // 创建一个StorageEvent事件
    var newStorageEvent = document.createEvent("StorageEvent");
    const storage = {
      setItem: function(k, val) {
        sessionStorage.setItem(k, val);
        // localStorage.setItem(k, val);
        // 初始化创建的事件
        newStorageEvent.initStorageEvent(
          "setItem",
          false,
          false,
          k,
          null,
          val,
          null,
          null
        );
        // 派发对象
        window.dispatchEvent(newStorageEvent);
      }
    };
    return storage.setItem(key, newVal);
  }
};

// 操作埋点（数据驾驶舱）
Vue.prototype.setCockpit = function(buttonType, menuId) {
  // 私有化部署不进行埋点
  if (!window.g.privatization) {
    buryingPoint({ buttonType, menuId });
  }
  // console.log("埋点");
};

const whiteList = ["/login"]; // 不重定向白名单
//校验token 免登录
router.beforeEach((to, from, next) => {
  
  // chrome
  document.body.scrollTop = 0;

  // firefox

  document.documentElement.scrollTop = 0;

  // safari
  // 解析 URL 查询参数，供下方免登分支使用（key / jmp / cubeCommonUserId）
  var url = document.location.href; // 获取url完整路径
  var theRequest = {};
  if (url.indexOf("?") != -1) {
    var str = url.substr(url.indexOf("?") + 1);
    var strs = str.split("&");
    for (var i = 0; i < strs.length; i++) {
      var st = strs[i].split("=");
      if (st.length > 1) theRequest[st[0]] = st[1];
    }
  }
  // this.user = theRequest.userId;

  window.pageYOffset = 0;

  // ========== 客户端免登：URL 带 ?key=xxx ==========
  // PC/客户端嵌入时携带 key，调 pcToken 换本站 token 后落 Cookie
  if (location.href.lastIndexOf("key") !== -1) {
    if (to.path === "/The_exam_will_begin" || to.path === "/test") {
      return next();
    }

    var param = location.href.lastIndexOf("key");
    var type = "client";
    var key = theRequest.key;
    delCookie();
    localStorage.clear();

    if (location.href.lastIndexOf("navtype") !== -1) {
      console.log(theRequest.navtype);
      localStorage.setItem("navtype_query", theRequest.navtype);
    }
    pcToken(key, type).then(res => {
      localStorage.setItem("pageSize", 10);
      if (res.code === 200) {
        setToken(res.data.token);
        setUuid(res.data.userId);
        // setTimeout(() => {
        info(res.data.userId).then(res => {
          if (res.code === 200) {
            setorganFlag(res.data.organFlag);
            localStorage.subjectId = res.data.subjectId;
            localStorage.subjectname = res.data.subjectName;
          }
        });
        getAccount().then(res => {
          if (res.code === 200) {
            setuserPhone(res.data.username);
            setroleId(res.data.roleId);
            setuserName(res.data.name);
            setheadPath(res.data.headPath);
            setschoolId(res.data.aff);
            setschoolCode(res.data.schoolCode);
            setrank(res.data.roleLevel);
            setIsAdmin(res.data.isAdmin);
            let index = url.indexOf("?");
            let subStr = url.slice(0, index);
            window.location.href = subStr;
            next();
          }
        });
        // }, 100);
      }
    });
    // window.location.replace();
    let index = url.indexOf("?");
    let subStr = url.slice(0, index);
    window.location.href = subStr;
    next();
  // ========== 安徽教育云单点登录回调：URL 带 ?jmp=<token>&userId=<id> ==========
  // 省平台登录成功后回跳本站；jmp 即为本站 token，无需再换票
  // 流程：清本地态 → 写入 token/userId → 拉用户信息 → 去掉 query 刷新进入已登录态
  } else if (location.href.lastIndexOf("jmp") !== -1) {
    delCookie();
    localStorage.clear();
    // console.log(theRequest)
    // jmp 直接作为本站 access_token；userId 写入本地
    setToken(theRequest.jmp);
    setUuid(theRequest.userId);
    // 拉个人信息（含 organFlag：1=安徽省平台对接用户）
    info(theRequest.userId).then(res => {
      if (res.code === 200) {
        setorganFlag(res.data.organFlag);
        localStorage.subjectId = res.data.subjectId;
        localStorage.subjectname = res.data.subjectName;
        localStorage.setItem("pageSize", 10);
      }
    });
    // 拉账号/角色信息，写入 Cookie，并清理回调参数后刷新
    getAccount().then(res => {
      if (res.code === 200) {
        setuserPhone(res.data.username);
        setroleId(res.data.roleId);
        setuserName(res.data.name);
        setheadPath(res.data.headPath);
        setschoolId(res.data.aff); // aff
        setareaId(res.data.areaId); // aff
        setschoolCode(res.data.schoolCode);
        setrank(res.data.roleLevel);
        setIsAdmin(res.data.isAdmin);
        menuButtonByToken(res.data.roleId).then(menuButton => {
          if (menuButton.code === 200) {
            let buttons = menuButton.data;
            localStorage.setItem("ButtonPermissions", JSON.stringify(buttons));
          }
        });
        // 去掉 ?jmp&userId，避免刷新重复走免登逻辑
        // window.location.href = `${window.location.protocol}//${window.location.host}`;
        var url = window.location.href; // 获取完整的URL
        var indexOfQueryString = url.indexOf('?'); // 判断URL中是否存在查询字符串部分
        if (indexOfQueryString !== -1) {
            var baseUrl = url.substring(0, indexOfQueryString); // 提取基本URL（不包含查询字符串）
        } else {
            var baseUrl = url; // URL没有查询字符串时直接返回原始URL
        }
        window.location.href = baseUrl
        next();
      }
    });
  // ========== 教育魔方免登：URL 带 ?cubeCommonUserId=xxx ==========
  } else if (location.href.lastIndexOf("cubeCommonUserId") !== -1) {
    delCookie();
    localStorage.clear();
    let cubeCommonUserId = theRequest.cubeCommonUserId;

    judgeCubeIsBind(cubeCommonUserId).then(res => {
      if (res.code === 200) {
        if (res.data !== "") {
          let userId = res.data.userId;
          setUuid(userId);
          // console.log(res.data);
          getBoundLoginInfo(window.g.platformCode, userId).then(response => {
            if (response.code === 200) {
              setToken(response.data.token);
              setTimeout(() => {
                info(userId).then(data => {
                  if (data.code === 200) {
                    console.log(data);
                    setorganFlag(data.data.organFlag);
                    localStorage.subjectId = data.data.subjectId;
                    localStorage.subjectname = data.data.subjectName;
                  }
                });
                getAccount().then(data => {
                  if (data.code === 200) {
                    setuserPhone(data.data.username);
                    setroleId(data.data.roleId);
                    setuserName(data.data.name);
                    setheadPath(data.data.headPath);
                    setschoolId(data.data.aff);
                    setschoolCode(data.data.schoolCode);
                    setrank(data.data.roleLevel);
                    setIsAdmin(data.data.isAdmin);
                    window.location.href = `${window.location.protocol}//${window.location.host}`;
                  }
                });
              }, 100);
            }
          });
        } else {
          store.commit("eduCubeState", true); // 打开绑定弹框
        }
      }
    });
  }
  // store.commit('montedMeta', to.meta);
  localStorage.metaobj = JSON.stringify(to.meta || {}); // 存meta,request.js文件使用
  if (getToken()) {
    // 如果有token从登录页面跳转 直接跳转到首页 /
    if (to.matched.length === 0) {
      next("/404"); // 判断此跳转路由的来源路由是否存在，存在的情况跳转到来源路由，否则跳转到404页面
    }
    if (store.state.groupState) {
      // console.log(store.state.groupState)
      setTimeout(() => {
        MessageBox.confirm(store.state.title, "", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          closeOnHashChange: false, // 定义和用法onhashchange 事件在当前 URL 的锚部分(以 '#' 号为开始) 发生改变时触发 (true 自动关闭， false不关闭)
          center: true
        })
          .then(() => {
            next();
            // 执行后将此状态转为初始状态false ,否则会一致弹出
            store.commit("setGroup", false);
          })
          .catch(() => {});
      }, 200);
      // console.log(store.state.groupState)
    } else {
      // 物联控制记录状态 不在当前页面时初始化标记（交互大屏，学习平板，录播一体机）
      if (to.meta.attribution !== "managementguanli") {
        localStorage.contorlModelIndex = 0;
      }
      next();
    }
    store.commit("loginState", false); // 关闭登录弹框
    // next() // 如果匹配到正确跳转
    // 没有登录
  } else {
    if (
      to.meta.type == "adhoc" ||
      to.meta.type == "error" ||
      to.meta.type == "wxAuxiliary" ||
      to.meta.type == "thirdPartyLogin"
    ) {
      // 无需登录 访问页面
      next();
      store.commit("loginState", false);
    } else {
      const Router = router.options.routes;
      let frontRouterList = []; // 全部前台路由

      for (let i = 0; i < Router.length; i++) {
        if (Router[i].path === "/") {
          Router[i].children.filter(item => {
            let obj = {};
            obj.path = item.path;
            obj.meta = item.meta;
            frontRouterList.push(obj);
          });
        }
      }

      function findElem(array, attr, val) {
        for (let i = 0; i < array.length; i++) {
          if (array[i][attr] == val) {
            return array[i]; //返回当前路由对象
          }
        }
        return -1;
      }
      let routerState = findElem(frontRouterList, "path", to.path); // 判断当前路由地址，是否为前台路由
      if (routerState !== -1) {
        if (routerState.meta.activePath === true) {
          next();
        } else {
          console.log(routerState);
          // 点击资源管理
          if (routerState.path === "/front/teacherResources") {
            localStorage.appointPath = "/front/teacherResources";
          }
          // else if(routerState.path === "/group/personal"){
          //     localStorage.appointPath = "/group/personal"
          // }else{
          //     localStorage.appointPath = "/group"
          // }
          store.commit("loginState", true);
          // console.log("未登录，没有访问权限")
        }
      } else {
        next({ path: "/front/home" });
        localStorage.appointPath = "/group/personal";
        // store.commit("loginState", true);
      }
    }
  }
});
new Vue({
  store,
  el: "#app",
  router,
  Base64,
  components: { App },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js